<template>
    <app-modal>
        <el-card class="box-card" >
            <h1></h1>
            <el-row type="flex" justify="space-between">
                <el-col :span="11">
                    <el-select v-model="menu" multiple placeholder="Select" @change="changueProjectc" style="width: 100%;">
                        <el-option
                            v-for="(item, index) in content"
                            :key="index"
                            :label="item.title"
                            :value="item.id" >
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="11">
                    <p>Submenú en: {{name}}</p>
                    <ul>
                        <li v-for="(item, index) in tmp_menu" :key="(index * 1000)">{{item.title}}</li>
                    </ul>
                </el-col>
            </el-row>
            <hr />
            <el-button @click="update">Guardar</el-button>
        </el-card>
    </app-modal>
</template>
<script>
	import ApiService from "@/common/api.service";
	import { API_UPLOADS } from "@/common/config";
    import Modal from '@/components/Dashboard/Modals/modal'

    export default {
        props: ['content', 'table', 'link', 'row'],
        components: {
            'app-modal': Modal,
		},
        created () {
            this.content.map( e => {
                if(this.link == e.id){
                    this.name = e.title
                }else{
                    return e
                }
            })
            this.getMenu()
        },
        data() {
            return {
                btn: 'Guardar',
                items: null,
                show: false,
                name: false,
                data: [],
                old_menu: [],
                menu: [],
                tmp_menu: []
            }
        },
        methods: {
            async getMenu(){
				ApiService.post("dashboard/table", {
					table: this.table,
					token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                    id: this.link,
                    row: this.row 
				}).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.data = response.data
                        this.menu = response.data.map( e => e.content_id  )
                        this.old_menu = response.data.map( e => e.content_id  )
                        setTimeout(() => { this.updateSubmenu(this.menu) }, 500);
                    }

				});
            },
            closeModal(){
                this.$root.$emit('closeModal')
            },
            changueProjectc($event){
                this.updateSubmenu($event)
            },
            updateSubmenu(e){
                this.tmp_menu = []
                this.content.filter( m => {
                    if(e.includes(m.id)){
                         this.tmp_menu.push({id:m.id, title:m.title})
                    }
                })
            },
            update() {
                this.menu.filter( e => {
                    // Insert 
                    if(this.old_menu.length > 0){
                        !this.old_menu.includes(e) ? this.insert({parent_content_id: this.link, content_id: parseInt(e)}) : false;
                    }else{
                        this.insert({parent_content_id: this.link, content_id: parseInt(e)})
                    }
                })
                this.old_menu.filter( e => {
                    // Eliminar
                    if(this.old_menu.length > 0){
                        !this.menu.includes(e) ? this.delete(e) : false;
                    }
                })
            },
            async insert(form){
                ApiService.post("dashboard/editform", {
                    table: this.table,
                    token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                    form: form,
                }).then(response => {
                    this.$notify({
                        title: 'Actualizado',
                        message: 'Submenú de ' + this.name + ' actualizado',
                        type: 'success'
                    })
                    setTimeout(() => {
                        this.closeModal()
                        
                    }, 1500);
                })
            },
            async delete(e){
                this.data.filter( item => {
                    if(item.content_id == e){
                        ApiService.post("dashboard/delete", {
                            table: this.table,
                            token: localStorage.getItem("token"),
                            project_id: localStorage.getItem("table"),
                            id: item.id
                        }).then(response => {
                            this.deleterow = response.data
                            this.$notify({
                                title: 'Actualizado',
                                message: 'Submenú de ' + this.name + ' actualizado',
                                type: 'success'
                            })
                            this.closeModal()
                        })
                    }
                })
            }
        },
    }
</script>

<style scoped>
    .item {
        font-size: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Modals/contentLink.vue